module.exports = __webpack_public_path__ + "img/ico3.1f0f8848.svg";